import type { IconSvgObject } from './types';

const CubeIcon: IconSvgObject = [
  ["path", { d: "M16.5 7.5L20.9969 3.00309M16.5 7.5H3.06446M16.5 7.5V20.9576M14 15.5H8.5M8.5 15.5V10.5M8.5 15.5L2.92021 21.0798M2.5 7.5V21.5H16.5L21.2071 16.7929C21.3946 16.6054 21.5 16.351 21.5 16.0858V2.5H7.5L2.5 7.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CubeIcon;
